export default {
    largeStep: Number,
    leftDragHandleTitle: String,
    max: Number,
    min: Number,
    orientation: String,
    rightDragHandleTitle: String,
    selectionEnd: Number,
    selectionStart: Number,
    smallStep: Number,
    tickPlacement: String,
    tooltip: Object,
    value: Array,

    // Events
    change: Function,
    slide: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoRangeSlider/RangeSliderProps.js